declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SectionData, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, FormOrganizer, SaveOTSectionDataRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest, FollicularScanDetailController, FollicularScanDetailRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, SaveFollicularScanDetailRequest, SaveFollicularScanOvaryDetailRequest, SaveIvfCycleTestDataRequest, SaveIvfCycleMedicineDataRequest, SaveTestMedCycleActivitiesRequest, IvfTreatmentPlanController, IvfTreatmentPlanRequest, SaveFollicularPickupsDetailV2Request, FollicularPickUpsByCodeController, FollicularPickUpsByCodeRequest, UpdateIvfCycleByActivityRequest, TreatmentCycleActiityMasterController, IvfCycleActivityMasterRequest, OocyteQualityAssessmentByCodeController, OocyteQualityAssessmentByCodeRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, OocyteMaturityByCycleController, OocyteMaturityByCycleRequest, SaveSingleWellFollicleRequest, SaveOocyteMaturityInfoRequest, SaveOocyteMorphologyInfoRequest, SaveIvfOocyteEmbryoStorageRequest, SaveCycleStatusRequest, OocyteMorphologyByCycleController, OocyteMorphologyByCycleRequest, OqaDetails, OocyteAbnormalitiesDetails, SpermSourceDetailsController, SpermSourceDetailsRequest, IvfSpermStoreByCodeController, IvfSpermStoreByCodeRequest, SaveSpermDetailsRequest, SaveSemenDataRequest, SaveIvfSpermStoreRequest, SaveSemanAnalysisRequest, GenericProcPostRequest, S_Methods, GetSpermSourceDetailsRequest, IvfExtraDataController, FTV, GenericParams, SaveIvfAdditionalDataRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe, OocyteAbPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbEditOvaryModal } from '../ivfworkbench/editovary.modal';
import { NgbAddScanTestModal } from '../ivfworkbench/addscantest.modal';
import { NgbAddScanMedicineModal } from '../ivfworkbench/addscanmedicine.modal';
import { NgbEditScanMedicineModal } from '../ivfworkbench/editscanmedicine.modal';
import { NgbEditScanTestModal } from '../ivfworkbench/editscantest.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { PrintService } from '../../../../services/print.service';
import { NgbSearchProviderModal } from '../ivfworkbench/searchprovider.modal';
import { NgbAddOqaModal } from '../ivfworkbench/addoqa.modal';
import { NgbEditOqaModal } from '../ivfworkbench/editoqa.modal';
import { NgbAddAbnormalOqaModal } from '../ivfworkbench/addabnormaloqa.modal';
import { NgbEditAbnormalOqaModal } from '../ivfworkbench/editabnormaloqa.modal';
import { NgbSearchDonarModal } from './searchdonar.modal';

@Component({
  selector: 'semanedit',
  templateUrl: './semanedit.modal.html',
  styleUrls: ['./semanedit.modal.scss']
})

export class NgbSemanEditModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
  @Input() ActorCode: number;
  @Input() TemplateName: string;
  @Input() CycleCode: number;
  @Input() FollicularGrowthCode: number;
  @Input() ActivityCode: number;
  @Input() PatientCode: number;
  @Input() FormattedCode: string;
  @Input() IsShowDetail: boolean = false;
  @Input() SectionSequenceNO: number;
  @Input() SectionTypeCode: number;
  @Input() Date: Date;
  @Input() Sign1: string;
  @Input() Sign2: string;
  @Input() TitleName: string;
  @Input() DOC: number;
  @Input() GradingModel: string;
  @Input() sectionData: SectionData;
  @Input() PatientReportCode: any;
  OvulationTriggerDate: NgbDateStruct;
  public ActivityDate: NgbDateStruct;
  public displayPatientdata: boolean = true;
  public displayscansdata: boolean = false;
  @Input() Eggsourcetype: string;
  public EggSourceType: string;
  ExpiryDate: NgbDateStruct;
  ExpiryDate2: NgbDateStruct;
  OvumPickupdate: NgbDateStruct;
  OvumPlannedPickupDate: NgbDateStruct;
  DateofSampleCollection: NgbDateStruct;
  //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
  @Input() ServiceCode: number;
  searchTitle: string;
  ScanDate: NgbDateStruct;
  NextScanDate: NgbDateStruct;
  public EggSourceActorCode: number;
  public OvulationtriggerDate: Date;
  //private isvisibleendo: boolean = true;
  public ApiResData: ApiResponseModel;
  // public data: string;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  private isvisible: boolean = true;
  public ActivityCodeNew: number;
  private isvisibleendo: boolean = true;
  public ProvidedName: string;
  public ProvidedCode: number;
  public ProvidedNumber: number;
  public ProvidedName2: string;
  public ProvidedCode2: number;
  public ProvidedNumber2: number;
  public Displaynew: boolean = false;
  public Displayold: boolean = true;
  //public IsSelected: boolean;
  ExtractionDate: NgbDateStruct;
  CurrentSaveSpermDetailsRequest: SaveSpermDetailsRequest;
  CurrentSaveSemenDataRequest: SaveSemenDataRequest;
  CurrentSaveIvfSpermStoreRequest: SaveIvfSpermStoreRequest;
  CurrentSaveCycleStatusRequest: SaveCycleStatusRequest;
  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  SelectedpatientDetails: TreatmentCyclesByActorCodeController;

  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadPatients() {
    // alert("patientsdetails");
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          this.SelectedpatientDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
          //this.LMPDate = this.SelectedTreatmentCycle.LMP;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadSperm();
          //this.LoadSA();
          //this.LoadStoragedata();
          this.LoadCycles();
          /// this.LoadDSAData();
          //this.LoadPlan();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe, public printService: PrintService,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private modalService: NgbModal,
    private tosterservice: NGXToastrService, private spinner: NgxSpinnerService, private parserFormatter: NgbDateParserFormatter, private filter2: OocyteAbPipe, ) { }
  ngOnInit() {
    // alert(this.GradingModel);
    this.ShowService = false;
    this.CurrentSaveSpermDetailsRequest = new SaveSpermDetailsRequest();
    this.CurrentSaveSpermDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveSemenDataRequest = new SaveSemenDataRequest();
    this.CurrentSaveSemenDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveIvfSpermStoreRequest = new SaveIvfSpermStoreRequest();
    this.CurrentSaveIvfSpermStoreRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveCycleStatusRequest = new SaveCycleStatusRequest();
    this.CurrentSaveCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.LoadPatients();
 


    //this.LoadScansData();
    //this.LoadOvaryData();

    //this.LoadTestData();
    //this.LoadMedicineData();

  }



  CurrentSpermSourceDetailsController: SpermSourceDetailsController[];
  SpermEndInfo: SpermSourceDetailsController;
  CurrentSpermSourceDetailsRequest: SpermSourceDetailsRequest;
  LoadSperm() {
    this.CurrentSpermSourceDetailsRequest = new SpermSourceDetailsRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentSpermSourceDetailsRequest.Branch = AppData.Instance().SelectedBranchCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    this.CurrentSpermSourceDetailsRequest.ConditionalOperator = 10;
    this.CurrentSpermSourceDetailsRequest.FromDate = new Date();
    this.CurrentSpermSourceDetailsRequest.ToDate = new Date();
    this.CurrentSpermSourceDetailsRequest.CycleCode = this.CycleCode;
    this.CurrentSpermSourceDetailsRequest.SemanDataCode = 0;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentSpermSourceDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetSpermSourceDetailsController();
  }

  GetSpermSourceDetailsController() {
    // this.StartRefreshing();


    this.actorservice.GetSpermSourceDetailsController(this.CurrentSpermSourceDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentSpermSourceDetailsController = this.ApiResData.Result;
          if (this.CurrentSpermSourceDetailsController.length > 0) {
            this.SpermEndInfo = this.CurrentSpermSourceDetailsController[0];
            if (this.SpermEndInfo.DateOfSampleCollection != null) {
              var SValidFrom = new Date(this.SpermEndInfo.DateOfSampleCollection);
              if (SValidFrom.getFullYear() > 1900) {
                console.log('this.UpdateDate >1990');
                this.DateofSampleCollection = {

                  year: SValidFrom.getFullYear(),
                  month: SValidFrom.getMonth() + 1,
                  day: SValidFrom.getDate()
                };

                this.ExtractionDate = {

                  year: SValidFrom.getFullYear(),
                  month: SValidFrom.getMonth() + 1,
                  day: SValidFrom.getDate()
                };
              }
            }



            //if (this.SpermEndInfo.DateOfSampleCollection != null) {
            //  var SValidFrom = new Date(this.SpermEndInfo.DateOfSampleCollection);
            //  if (SValidFrom.getFullYear() > 1900) {
            //    console.log('this.UpdateDate >1990');
            //    //this.ExtractionDate = {

            //    //  year: SValidFrom.getFullYear(),
            //    //  month: SValidFrom.getMonth() + 1,
            //    //  day: SValidFrom.getDate()
            //    //}
            //  }
            //}

            //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
            //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
            //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
            //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
            // this.stopRefreshing();
          }
          else {
            this.SpermEndInfo = new SpermSourceDetailsController();
          }
          this.LoadSA();
         // this.LoadPatients();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentSemanAnalysisController: IvfExtraDataController[];
  SpermInfo: IvfExtraDataController;
  Viability: IvfExtraDataController;
  
  LoadSA() {
    var getReq = new GetSpermSourceDetailsRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101044;
    getReq.Branch = AppData.Instance().SelectedBranchCode;
    getReq.CycleCode = this.CycleCode;
    getReq.SemanDataCode = 0;
    getReq.FromDate = new Date();
    getReq.ToDate = new Date();
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101044;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentSemanAnalysisController = JSON.parse(data);
          if (this.CurrentSemanAnalysisController.length == 1 && this.CurrentSemanAnalysisController[0].DataContext == 'NA') {
            this.SpermInfo = new IvfExtraDataController();// this.CurrentSemanAnalysisController.find(x => x.DataContext == 'SlugishMotile'); //[0];
            this.Viability = new IvfExtraDataController();//this.CurrentSemanAnalysisController.find(x => x.DataContext == 'Viability'); //[0];
            this.SpermInfo.DataContext = 'SlugishMotile';
            this.Viability.DataContext = 'Viability';
            this.SpermInfo.CycleCode = this.CycleCode;
            this.Viability.CycleCode = this.CycleCode;
            this.SpermInfo.DataType = 'string';
            this.Viability.DataType = 'string';

          }
          else {
            if (this.CurrentSemanAnalysisController.find(x => x.DataContext == 'SlugishMotile') != null)
              this.SpermInfo = this.CurrentSemanAnalysisController.find(x => x.DataContext == 'SlugishMotile');
            else {
              this.SpermInfo = new IvfExtraDataController();// this.CurrentSemanAnalysisController.find(x => x.DataContext == 'SlugishMotile'); //[0];
           
              this.SpermInfo.DataContext = 'SlugishMotile';
           
              this.SpermInfo.CycleCode = this.CycleCode;
           
              this.SpermInfo.DataType = 'string';
           
            }
            if (this.CurrentSemanAnalysisController.find(x => x.DataContext == 'Viability') != null)
              this.Viability = this.CurrentSemanAnalysisController.find(x => x.DataContext == 'Viability');
            else {              
              this.Viability = new IvfExtraDataController();//this.CurrentSemanAnalysisController.find(x => x.DataContext == 'Viability'); //[0];
              
              this.Viability.DataContext = 'Viability';
              
              this.Viability.CycleCode = this.CycleCode;
              
              this.Viability.DataType = 'string';
            }
          }
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();

          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
          this.LoadStoragedata();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  CurrentIvfSpermStoreByCodeController: IvfSpermStoreByCodeController[];
  SpermSourceInfo: IvfSpermStoreByCodeController;
  CurrentIvfSpermStoreByCodeRequest: IvfSpermStoreByCodeRequest;
  LoadStoragedata() {
    this.CurrentIvfSpermStoreByCodeRequest = new IvfSpermStoreByCodeRequest();
    this.CurrentIvfSpermStoreByCodeRequest.TreatmentCycle = this.CycleCode;
    this.CurrentIvfSpermStoreByCodeRequest.ActorCode = this.ActorCode;
    this.CurrentIvfSpermStoreByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetIvfSpermStoreByCodeController();
  }

  GetIvfSpermStoreByCodeController() {
    // this.StartRefreshing();


    this.actorservice.GetIvfSpermStoreByCodeController(this.CurrentIvfSpermStoreByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentIvfSpermStoreByCodeController = this.ApiResData.Result;
          if (this.CurrentIvfSpermStoreByCodeController
            != null &&
            this.CurrentIvfSpermStoreByCodeController.length == 1) {
            this.SpermSourceInfo = this.CurrentIvfSpermStoreByCodeController[0];
          }
          else {
            this.SpermSourceInfo = new IvfSpermStoreByCodeController();
            this.SpermSourceInfo.StorageUnitDetails = "";
            this.SpermSourceInfo.StorageUnitType = "";
            this.SpermSourceInfo.Volume = 0;
            this.SpermSourceInfo.VolumeUnits = "";
            this.SpermSourceInfo.SpermStoreCode = 0;





          }

          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          // this.stopRefreshing();
          //this.LoadPatients();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
  SemanAnalysis: TreatmentCycleStatusController[];
  SemanAnalysis2: TreatmentCycleStatusController;
  CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
  LoadCycles() {
    this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetTreatmentCycleStatusController();
  }

  GetTreatmentCycleStatusController() {
    // this.StartRefreshing();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();
    //this.spinner.show();
    this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
          this.SemanAnalysis = this.ApiResData.Result;
          var Semanlist = this.SemanAnalysis.filter(
            function (a) {
              return a.PhaseActivity == "Semen Analysis";
            });
          this.SemanAnalysis = Semanlist;
          this.SemanAnalysis2 = this.SemanAnalysis[0];
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();
     
         

          this.LoadDSAData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
  DSADetails: DSAActivityByCycleCodeController;
  CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

  LoadDSAData() {
    //alert("ScansData")
    this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDSAActivityByCycleCodeController();
  }

  GetDSAActivityByCycleCodeController() {
    //this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.CycleCode;
    this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
    //this.EggSourceType = this.SelectedpatientDetails.EggSourceType;
    this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.ActorCode;//this.GetActorCode(this.Eggsourcetype);
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;

          //alert(this.SelectedpatientDetails.EggSourceType);
          this.DSADetails = this.GetCycleActivity2(
            this.GetActorCode(this.SelectedpatientDetails.EggSourceType),
            this.SelectedpatientDetails.ProtocolStartDate)[0];

          this.LoadSperm();
   

          //alert(this.DSADetails);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

          //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
          //var list = this.CurrentDSAActivityByCycleCodeController.filter(


          //    function (a) {
          //        var Date = this.FollicularScanEndInfo.ScanDate;
          //        var ActorCode = this.SelectedpatientDetails.ActorID;
          //        return a.ActivityDate == Date && a.ActorCode == ActorCode
          //    });

          //this.CurrentDSAActivityByCycleCodeController = list;
          //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
          //alert(this.Doc1);
          //alert(this.Antag);
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  //    GetDsADetails(ActorCode: number, Date: Date) {


  //}
  GetCycleActivity2(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
    //alert(ReceipientActorCode);
    //alert(TransferDateNew);
    return this.CurrentDSAActivityByCycleCodeController.filter(
      function (v, i, d) {

        return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
      }
    )

  }
  GetActorCode(EggSourceType: string): number {
    // alert("new");
    if (EggSourceType == 'Donor') {
      var DonorActorCode = this.SelectedpatientDetails.EggActorCode;
      return DonorActorCode;
    }
    else if (EggSourceType == 'Self') {
      var OwnerActorCode = this.SelectedpatientDetails.EggActorCode;
      return OwnerActorCode;
    }
  }
  CurrentTreatmentCycleActiityMasterController: TreatmentCycleActiityMasterController[];
  ActivityCodeInfo: TreatmentCycleActiityMasterController;
  CurrentIvfCycleActivityMasterRequest: IvfCycleActivityMasterRequest;

  LoadMasterReq() {
    //alert("ScansData")
    this.CurrentIvfCycleActivityMasterRequest = new IvfCycleActivityMasterRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleActivityMasterRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCycleActiityMasterController();
  }

  GetTreatmentCycleActiityMasterController() {
    //this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    //this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.CycleCode;
    this.CurrentIvfCycleActivityMasterRequest.ConditionalOperator = 10;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetTreatmentCycleActiityMasterController(this.CurrentIvfCycleActivityMasterRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentTreatmentCycleActiityMasterController = this.ApiResData.Result;

          //this.LoadTestData();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.GetCycleActivity(this.ActorCode, this.ScanDate);

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): TreatmentCycleActiityMasterController[] {
    //alert(ReceipientActorCode);
    //alert(TransferDateNew);
    return this.CurrentTreatmentCycleActiityMasterController.filter(
      function (v, i, d) {

        return v.ActorID == ReceipientActorCode && v.DocDate == TransferDateNew;
      }
    )

  }

  SelectedValue: string;
  SelectedSource: string;
  patientName: string;
  PatientFomratted: string;
  patientActorCode: number;

  SelectDonorForEgg() {
    const modalRef = this.modalService.open(NgbSearchDonarModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.patientName = receivedEntry.make;
      this.PatientFomratted = receivedEntry.value;
      this.patientActorCode = receivedEntry.key2;
      //alert(this.Code);
    })
  }
  onChange(event: any) {

    this.SelectedValue = event;
    //if (this.SelectedValue == "Fresh") {
    //  this.CurrentSaveSpermDetailsRequest.SpermSourceCode = this.SpermEndInfo.OwnerActorCode;
    //  this.CurrentSaveSpermDetailsRequest.SpermSourceFormattedCode = this.SpermEndInfo.OwnerFormattedCode;
    //}
    //else {
    //  this.CurrentSaveSpermDetailsRequest.SpermSourceCode = this.patientActorCode;
    //  this.CurrentSaveSpermDetailsRequest.SpermSourceFormattedCode = this.PatientFomratted;
    //}
    //alert(this.SelectedValue);
    // ... do other stuff here ...
  }
  onChange2(event: any) {
    this.SelectedSource = event;
  }

  onSubmit() {

    this.spinner.show();
    this.CurrentSaveSpermDetailsRequest.ConditionalOperator = 10;
    this.CurrentSaveSpermDetailsRequest.SpermSource = this.SpermEndInfo.SpermSource;
    if (this.CurrentSaveSpermDetailsRequest.SpermSource == "Fresh") {
      this.CurrentSaveSpermDetailsRequest.SpermSourceCode = this.SpermEndInfo.OwnerActorCode;
      this.CurrentSaveSpermDetailsRequest.SpermSourceFormattedCode = this.SpermEndInfo.OwnerFormattedCode;
    }
    else {
      this.CurrentSaveSpermDetailsRequest.SpermSourceFormattedCode = this.PatientFomratted;
      this.CurrentSaveSpermDetailsRequest.SpermSourceCode = this.patientActorCode;
    }
    this.CurrentSaveSpermDetailsRequest.SpermSourceFrom = this.SpermEndInfo.SpermSourceFrom;
    this.CurrentSaveSpermDetailsRequest.StorageLocationDetails = this.SpermEndInfo.StorageLocationDetails;
    this.CurrentSaveSpermDetailsRequest.SpermRetrieval = this.SpermEndInfo.SpermRetrieval;
    this.CurrentSaveSpermDetailsRequest.ExtractionDate = new Date(this.parserFormatter.format(this.ExtractionDate));
    //this.CurrentSaveSpermDetailsRequest.ExtractionTime = Date.now();
    this.CurrentSaveSpermDetailsRequest.ExtractionTime = new Date();
    this.CurrentSaveSpermDetailsRequest.ExtractionTimeText = this.SpermEndInfo.ExtractionTimeText;
    this.CurrentSaveSpermDetailsRequest.TreatmentCycleCode = this.CycleCode;
    //this.CurrentSaveSpermDetailsRequest.SpermSourceCode = this.patientActorCode;
    //if (this.CurrentSaveSpermDetailsRequest.SpermSourceCode = 0) {
    //  this.CurrentSaveSpermDetailsRequest.SpermSourceCode =0;
    //}
    //this.CurrentSaveSpermDetailsRequest.SpermSourceFormattedCode = this.PatientFomratted;
    //if (this.CurrentSaveSpermDetailsRequest.SpermSourceFormattedCode = "null") {
    //  this.CurrentSaveSpermDetailsRequest.SpermSourceFormattedCode = this.SpermEndInfo.OwnerFormattedCode;
    //}
    this.CurrentSaveSpermDetailsRequest.HasICSI = false;
    this.CurrentSaveSpermDetailsRequest.HASIMSI = false;
    this.CurrentSaveSpermDetailsRequest.hasIVF = false;
    this.CurrentSaveSpermDetailsRequest.ICSIDetails = "";
    this.CurrentSaveSpermDetailsRequest.ICSIPerformedBy = 0;
    this.CurrentSaveSpermDetailsRequest.ICSIPerformedByName = "";
    this.CurrentSaveSpermDetailsRequest.IMSIDetails = "";
    this.CurrentSaveSpermDetailsRequest.IMSIPerformedBy = 0;;
    this.CurrentSaveSpermDetailsRequest.IMSIPerformedByName = "";
    this.CurrentSaveSpermDetailsRequest.IVFDetails = "";
    this.CurrentSaveSpermDetailsRequest.IVFPerformedBy = 0;
    this.CurrentSaveSpermDetailsRequest.Remarks = "";
    this.CurrentSaveSpermDetailsRequest.IVFPerformedByName = "";
    this.CurrentSaveSpermDetailsRequest.Remarks2 = "";
    this.CurrentSaveSpermDetailsRequest.Remarks3 = "";
    this.CurrentSaveSpermDetailsRequest.CycleOocyteQualityCode = 0;
    //this.CurrentSaveSpermDetailsRequest.ExtractionTime = "10:00";
    this.actorservice.SaveSpermDetails(this.CurrentSaveSpermDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );


  }
  onSubmit2() {
    this.spinner.show();
    this.CurrentSaveSemenDataRequest.ConditionalOperator = 1;
    this.CurrentSaveSemenDataRequest.DateofSampleCollection = new Date(this.parserFormatter.format(this.DateofSampleCollection));
    this.CurrentSaveSemenDataRequest.TimeofSampleCollection = this.SpermEndInfo.TimeOFSampleCollection;
    this.CurrentSaveSemenDataRequest.Volume = this.SpermEndInfo.Volume;
    this.CurrentSaveSemenDataRequest.Count = this.SpermEndInfo.Count;
    this.CurrentSaveSemenDataRequest.MotileSpermMotility = this.SpermEndInfo.MotileSpermMotility;
    this.CurrentSaveSemenDataRequest.ActiveProgressiveMotility = this.SpermEndInfo.ActiveProgressiveMotility;
    this.CurrentSaveSemenDataRequest.CellularDebris = this.SpermEndInfo.CellularDebris;
    this.CurrentSaveSemenDataRequest.MethodofPreparation = this.SpermEndInfo.MethodOfPreparation;
    this.CurrentSaveSemenDataRequest.IncubationTime = this.SpermEndInfo.IncubationTime;
    this.CurrentSaveSemenDataRequest.MotileSpermCount = this.SpermEndInfo.MotileSpermCount;
    this.CurrentSaveSemenDataRequest.Motility = this.SpermEndInfo.Motility;
    this.CurrentSaveSemenDataRequest.Notes = this.SpermEndInfo.Notes;
    this.CurrentSaveSemenDataRequest.SlideObserved = this.SpermEndInfo.SlideObserved;
    this.CurrentSaveSemenDataRequest.CatheterLoadDate = new Date(this.parserFormatter.format(this.DateofSampleCollection));
    this.CurrentSaveSemenDataRequest.CatheterLoadedBy = this.SpermEndInfo.CatheterLoadedBy;
    this.CurrentSaveSemenDataRequest.CatheterLoadedByName = this.SpermEndInfo.CatheterLoadedByName;
    this.CurrentSaveSemenDataRequest.CatheterLoadTime = new Date();
    this.CurrentSaveSemenDataRequest.Day = 1;
    this.CurrentSaveSemenDataRequest.DFI = this.SpermEndInfo.DFI;
    this.CurrentSaveSemenDataRequest.ProgressiveMotility = this.SpermEndInfo.ProgressiveMotility;
    this.CurrentSaveSemenDataRequest.Morphology = this.SpermEndInfo.Morphology;
    this.CurrentSaveSemenDataRequest.NonProgressiveMotility = this.SpermEndInfo.NonProgressiveMotility;
    this.CurrentSaveSemenDataRequest.IterationType = "Pre-Wash";
    this.CurrentSaveSemenDataRequest.PreparedBy = this.SpermEndInfo.PreparedBy;
    this.CurrentSaveSemenDataRequest.PreparedByName = this.SpermEndInfo.PreparedByName;
    this.CurrentSaveSemenDataRequest.ReadyForInsemination = this.SpermEndInfo.ReadyForInsemination;
    this.CurrentSaveSemenDataRequest.SampleType = this.SpermEndInfo.SampleType;
    this.CurrentSaveSemenDataRequest.TreatmentCycle = this.CycleCode;

    this.CurrentSaveSemenDataRequest.SlideObservedBy = this.SpermEndInfo.SlideObservedBy;
    this.CurrentSaveSemenDataRequest.SlideObservedByName = this.SpermEndInfo.SlideObservedByName;


    this.actorservice.SaveSemenData(this.CurrentSaveSemenDataRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            //this.activeModal.close();
            //this.clearData();
            this.SaveData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );


  }
  public SlugishMotile: string;
  public Viability2: string;
  SaveData() {
    var saveReq = new SaveIvfAdditionalDataRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40380;
    var getReq: GenericParams = new GenericParams();
    getReq.Params = [
      new FTV(this.SpermInfo.DataContext, this.SpermInfo.DataType, this.SpermInfo.DataValue),
      new FTV(this.Viability.DataContext, this.Viability.DataType, this.Viability.DataValue)
    ];
    
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.FacilityCode = AppData.Instance().SelectedBranchCode;
    saveReq.TreatmentCycle = this.CycleCode;
    saveReq.QueryData = JSON.stringify(getReq);
    //saveReq.SlugishMotile = this.SpermInfo.DataValue;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40380;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            //this.activeModal.close();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  onSubmitStore() {
    this.spinner.show();
    if (this.SpermSourceInfo.SpermStoreCode == 0) {
      this.CurrentSaveIvfSpermStoreRequest.ConditionalOperator = 10;

    }
    else {
      this.CurrentSaveIvfSpermStoreRequest.ConditionalOperator = 20;
    }
    //this.CurrentSaveIvfSpermStoreRequest.ConditionalOperator = 10;
    this.CurrentSaveIvfSpermStoreRequest.TreatmentCycle = this.CycleCode;
    this.CurrentSaveIvfSpermStoreRequest.CreatedUser = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSaveIvfSpermStoreRequest.LastUpdateDate = new Date();
    this.CurrentSaveIvfSpermStoreRequest.LastUpdateTime = new Date();
    this.CurrentSaveIvfSpermStoreRequest.Status = "";
    this.CurrentSaveIvfSpermStoreRequest.ActorCode = this.ActorCode;
    this.CurrentSaveIvfSpermStoreRequest.SpermStoreCode = this.SpermSourceInfo.SpermStoreCode;
    this.CurrentSaveIvfSpermStoreRequest.StorageUnitDetails = this.SpermSourceInfo.StorageUnitDetails;
    this.CurrentSaveIvfSpermStoreRequest.Volume = this.SpermSourceInfo.Volume;
    this.CurrentSaveIvfSpermStoreRequest.VolumeUnits = this.SpermSourceInfo.VolumeUnits;
    this.CurrentSaveIvfSpermStoreRequest.StorageUnitType = this.SpermSourceInfo.StorageUnitType;

    this.actorservice.SaveIvfSpermStore(this.CurrentSaveIvfSpermStoreRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );


  }
  SemenAnalysis() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.SemenAnalysisCompleted();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  SemenAnalysisCompleted() {


    console.log('..................');
    //this.StartRefreshing();

    this.CurrentSaveCycleStatusRequest.ConditionalOperator = 40;
    this.CurrentSaveCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
    this.CurrentSaveCycleStatusRequest.ActivityName = "Semen Analysis";
    this.CurrentSaveCycleStatusRequest.ActivityStatus = "Completed";
    this.CurrentSaveCycleStatusRequest.Remarks = "None";
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveCycleStatus(this.CurrentSaveCycleStatusRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.LoadCycles();
            //this.LoadScansData();
            //this.LoadOvaryData();
            //this.LoadTestData();
            //this.LoadMedicineData();
            //this.ShowList = true;
            //this.LoadMedicineData();

            //this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  SemenAnalysisIUI() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.SemenAnalysisIUICompleted();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  SemenAnalysisIUICompleted() {


    console.log('..................');
    //this.StartRefreshing();

    this.CurrentSaveSemenDataRequest.ConditionalOperator = 2;
    this.CurrentSaveSemenDataRequest.DateofSampleCollection = new Date(this.parserFormatter.format(this.DateofSampleCollection));
    this.CurrentSaveSemenDataRequest.TimeofSampleCollection = this.SpermEndInfo.TimeOFSampleCollection;
    this.CurrentSaveSemenDataRequest.Volume = 0;
    this.CurrentSaveSemenDataRequest.Count = 0;
    this.CurrentSaveSemenDataRequest.MotileSpermMotility = 0;
    this.CurrentSaveSemenDataRequest.ActiveProgressiveMotility = 0;
    this.CurrentSaveSemenDataRequest.CellularDebris = "";
    this.CurrentSaveSemenDataRequest.MethodofPreparation = "";
    this.CurrentSaveSemenDataRequest.IncubationTime = 0;
    this.CurrentSaveSemenDataRequest.MotileSpermCount = 0;
    this.CurrentSaveSemenDataRequest.Motility = 0;
    this.CurrentSaveSemenDataRequest.Notes = "";
    this.CurrentSaveSemenDataRequest.SlideObserved = false;
    this.CurrentSaveSemenDataRequest.CatheterLoadDate = new Date(this.parserFormatter.format(this.DateofSampleCollection));
    this.CurrentSaveSemenDataRequest.CatheterLoadedBy = 0;
    this.CurrentSaveSemenDataRequest.CatheterLoadedByName = "";
    this.CurrentSaveSemenDataRequest.CatheterLoadTime = new Date();
    this.CurrentSaveSemenDataRequest.Day = 1;
    this.CurrentSaveSemenDataRequest.DFI = "";
    this.CurrentSaveSemenDataRequest.ProgressiveMotility = "";
    this.CurrentSaveSemenDataRequest.Morphology = "";
    this.CurrentSaveSemenDataRequest.NonProgressiveMotility = "";
    this.CurrentSaveSemenDataRequest.IterationType = "";
    this.CurrentSaveSemenDataRequest.PreparedBy = 0;
    this.CurrentSaveSemenDataRequest.PreparedByName = "";
    this.CurrentSaveSemenDataRequest.ReadyForInsemination = true;
    this.CurrentSaveSemenDataRequest.SampleType = "";
    this.CurrentSaveSemenDataRequest.TreatmentCycle = this.CycleCode;

    this.CurrentSaveSemenDataRequest.SlideObservedBy = 0;
    this.CurrentSaveSemenDataRequest.SlideObservedByName = "";




    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveSemenData(this.CurrentSaveSemenDataRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.LoadCycles();
            //this.LoadScansData();
            //this.LoadOvaryData();
            //this.LoadTestData();
            //this.LoadMedicineData();
            //this.ShowList = true;
            //this.LoadMedicineData();

            //this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

  BackToPatientdata() {
    this.displayPatientdata = true;
    this.displayscansdata = false;
  }
  BackTodashboard2() {
    //this.Showivf = true;
    //this.Showscan = false;
    this.router.navigate(['healins/ivfworkbench']);
  }
  printsource() {
    this.printService.printDocument("spermsourcedetails",
      {
        Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
        TreatmentCycleCodedata: this.SelectedpatientDetails.Code, TotalOocytes: this.SpermEndInfo.TotalOocytes, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate,
        MaleSource: this.SpermEndInfo.SpermSource, SourceFrom: this.SpermEndInfo.SpermSourceFrom, ExtDate: this.SpermEndInfo.DateOfSampleCollection, ExtTime: this.SpermEndInfo.TimeOFSampleCollection, StorageLoc: this.SpermEndInfo.StorageLocationDetails, Technique: this.SpermEndInfo.SpermRetrieval,
        DateofsampleCollection: this.SpermEndInfo.DateOfSampleCollection, TimeofsampleCollection: this.SpermEndInfo.TimeOFSampleCollection, Volume: this.SpermEndInfo.Volume, Count: this.SpermEndInfo.Count, MotileSpermMotility: this.SpermEndInfo.MotileSpermMotility, ActiveProgressivemotility: this.SpermEndInfo.ActiveProgressiveMotility, CellularDebris: this.SpermEndInfo.CellularDebris, MethodofPreparation: this.SpermEndInfo.MethodOfPreparation,
        IncubationTime: this.SpermEndInfo.IncubationTime, MotileSpermCount: this.SpermEndInfo.MotileSpermCount, Motility: this.SpermEndInfo.Motility, Notes: this.SpermEndInfo.Notes, SlideObserved: this.SpermEndInfo.SlideObserved,
        StorageDetails: this.SpermSourceInfo.StorageUnitDetails, StorageType: this.SpermSourceInfo.StorageUnitType, StorageVolume: this.SpermSourceInfo.Volume, StorageVolumeunits: this.SpermSourceInfo.VolumeUnits,
      }
    );
  }

  printsourcedroplet() {
    this.printService.printDocument("spermsourcedetailsdroplet",
      {
        Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
        TreatmentCycleCodedata: this.SelectedpatientDetails.Code, TotalOocytes: this.SpermEndInfo.TotalOocytes, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate,
        MaleSource: this.SpermEndInfo.SpermSource, SourceFrom: this.SpermEndInfo.SpermSourceFrom, ExtDate: this.SpermEndInfo.DateOfSampleCollection, ExtTime: this.SpermEndInfo.TimeOFSampleCollection, StorageLoc: this.SpermEndInfo.StorageLocationDetails, Technique: this.SpermEndInfo.SpermRetrieval,
        DateofsampleCollection: this.SpermEndInfo.DateOfSampleCollection, TimeofsampleCollection: this.SpermEndInfo.TimeOFSampleCollection, Volume: this.SpermEndInfo.Volume, Count: this.SpermEndInfo.Count, TotalMotility: this.SpermEndInfo.ActiveProgressiveMotility, ActiveProgressivemotility: this.SpermEndInfo.ActiveProgressiveMotility, CellularDebris: this.SpermEndInfo.CellularDebris, MethodofPreparation: this.SpermEndInfo.MethodOfPreparation,
        IncubationTime: this.SpermEndInfo.IncubationTime, MotileSpermCount: this.SpermEndInfo.MotileSpermCount, Motility: this.SpermEndInfo.Motility, Notes: this.SpermEndInfo.Notes, SlideObserved: this.SpermEndInfo.SlideObserved,
        ProgressiveMotility: this.SpermEndInfo.ProgressiveMotility, Morphology: this.SpermEndInfo.Morphology, NonProgressiveMotility: this.SpermEndInfo.NonProgressiveMotility, DFI: this.SpermEndInfo.DFI,
        StorageDetails: this.SpermSourceInfo.StorageUnitDetails, StorageType: this.SpermSourceInfo.StorageUnitType, StorageVolume: this.SpermSourceInfo.Volume, StorageVolumeunits: this.SpermSourceInfo.VolumeUnits,

      }
    );
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }





}
export class OocyteStoreItem {

  public OocyteEmbryoStorageCode: number;

  public WellNo: number;
  public StorageUnitType: string;
  public StorageUnitDetails: string;
  public Status: string;

  public Morphology: string;

  public IsSelected: boolean;
}
